// Used to prevent circle dependency.

export const headerHeight = '6rem';
export const headerPadding = '1.2rem';
export const headerInnerHeight = `calc(${headerHeight} - 2 * ${headerPadding})`;
